import React, {useEffect, useState} from "react";
import {LeftOutlined} from "@ant-design/icons";
import {Button, Col, DatePicker, Pagination, Result, Row, Skeleton, Space} from "antd";
import moment from "moment";
import {useRequest} from "ahooks";
import QueryTabs from "@/page-components/verify/QueryResult/tabs";
import PcComponentWrapper from "@/components/PcComponentWrapper";
import PaperView from "@/page-components/verify/QueryResult/paper_view";
import {VerifyData, VerifyOtherpeopleData} from "@/types/verify";
import CertPaper from "@/page-components/verify/certPaper";
import styles from "./styles.module.less";

enum QueryMethod {
  forMe=1,
  forOther
}

type TVerifyQuery = {
  otherPeopleData:VerifyOtherpeopleData,
  method: QueryMethod,
  page: number;
  onBack:() => void;
  data: VerifyData[];
  total: number;
  onQuery:(params:{
    status?:'all' | 'pass'
    page?: number,
    pagesize?: number,
    starttime?: number,
    endtime?: number
  }) => Promise<{message: boolean}>;
}

const { RangePicker } = DatePicker;

const VerifyQueryResult:React.FC<TVerifyQuery> = ({otherPeopleData,method,page,onQuery,onBack, data, total}) => {
  const [signUpTime, setSignUpTime] = useState<number  | null>(null)
  const [certnoUrl, setCertnoUrl] = useState<string | null>(null);
  const [reviewPaper, setReviewPaper] = useState(false);
  const {loading,run:doQuery} = useRequest((params) => {
    return onQuery({...params});
  },{
    manual: true,
    onSuccess:(res) => {
      console.log('查询结果来了');
      console.log(res);
    }
  })
  useEffect(() => {
    console.log('method是');
    console.log(method);
    if (method === QueryMethod.forOther){
      setReviewPaper(true);
    }
  }, [method]);

  const goBack = () => {
    if (method === QueryMethod.forMe){
      if (reviewPaper){
        setReviewPaper(false);
      } else {
        onBack();
      }
    } else {
      onBack();
    }
  }
  return (
    <div className={styles.verify_result_page}>
      <Space className={styles.verify_result_page_header} onClick={goBack}>
        <LeftOutlined className={styles.verify_result_page_header_icon}/>
        查询结果
      </Space>
      {reviewPaper ? <CertPaper time={method === QueryMethod.forMe ? signUpTime: otherPeopleData.issuanceDate} url={method === QueryMethod.forMe ? certnoUrl: otherPeopleData.certnoUrl} onSubmit={goBack}/> : (
        <div className={styles.verify_result_page_body}>
          <div className={styles.header}>
            <QueryTabs onChange={async (status) => {
              await doQuery({status,page:0,pagesize:20})
            }}/>
            <PcComponentWrapper>
              <Space>
                <p>报名时间</p>
                <RangePicker onChange={(dates) => {
                  console.log('onchange触发');
                  console.log(dates);
                  if (dates){
                    const datetimeStamp:number[] = []
                    dates.forEach((date,index) => {
                      if (index === 0){
                        datetimeStamp.push(moment(date).startOf('day').valueOf())
                      } else {
                        datetimeStamp.push(moment(date).endOf('day').valueOf())
                      }
                    });
                    if (datetimeStamp.length === 2){
                      doQuery({page:0,startTime: datetimeStamp[0],endTime: datetimeStamp[1]})
                    }
                  } else {
                    doQuery({page:0,startTime: null,endTime: null})
                  }
                }}/>
              </Space>
            </PcComponentWrapper>
          </div>
          {loading ? <Skeleton /> : (
            <div className={styles.body}>
              {data.length === 0 ? (
                <Result
                  icon={<img style={{width:200,height: 200}} alt="" src="/img/none.png"/>}
                  title={<p className={styles.empty_text}>未查询到相关记录</p>}
                />
              ) : (
                <>
                  <Row gutter={[24,24]}>
                    {data.map(item => {
                      return (
                        <Col key={Math.random()} xs={24} md={12} className={styles.body_item_wrapper}>
                          <div className={styles.item}>
                            <div className={styles.item_title}>{item.certName}</div>
                            {item.entryTime && (
                              <div className={styles.item_time}>{moment(item.entryTime).format('YYYY年MM月DD日 HH:mm:ss')}报名</div>
                            )}
                            <Space size={16}>
                              {item.isPass && (
                                <Button type='primary' onClick={() => {
                                  setReviewPaper(true);
                                  setCertnoUrl(item.certnoUrl);
                                  setSignUpTime(item.issueDate)
                                }}>查看证书</Button>
                              )}
                              {item.paperId && <PaperView paperId={item.paperId}/>}
                            </Space>
                            <img className={styles.item_icon} src={item.isPass ? "/img/verify_pass.png" : "/img/verify_nopass.png"} alt=""/>
                          </div>
                        </Col>
                      )
                    })}
                  </Row>
                  <Pagination
                    current={page+1}
                    onChange={(async (comPage, pageSize) => {
                      await doQuery({page: comPage - 1,pagesize:pageSize})
                    })}
                    pageSize={20}
                    className={styles.pagination_row}
                    total={total}
                  />
                </>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  )
}
export default VerifyQueryResult;
